import React, { useState } from 'react';
import { searchPosts } from '../api/community';
import PostCard from './PostCard';

// Search input + results (replaces PostList view when user submits).
// onClear callback notifies parent to revert to normal list view.

export default function CommunitySearch({ category, onClear }) {
  const [query, setQuery] = useState('');
  const [submittedQuery, setSubmittedQuery] = useState('');
  const [results, setResults] = useState(null); // null = no search yet
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const q = query.trim();
    if (q.length < 2) {
      setError('검색어는 2자 이상');
      return;
    }
    setLoading(true); setError(null);
    try {
      const data = await searchPosts({ q, category });
      setResults(data.posts || []);
      setSubmittedQuery(q);
    } catch (err) {
      console.error('[CommunitySearch] error', err);
      setError(err.message || '검색 실패');
    }
    setLoading(false);
  };

  const handleClear = () => {
    setQuery('');
    setSubmittedQuery('');
    setResults(null);
    setError(null);
    if (onClear) onClear();
  };

  return (
    <div style={{ marginBottom: 20 }}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
        <input
          className="input"
          type="text"
          placeholder="제목·본문 검색 (2자 이상)"
          value={query}
          onChange={e => setQuery(e.target.value)}
          style={{ flex: 1, minWidth: 0 }}
        />
        <button type="submit" className="btn btn-primary"
          disabled={loading || query.trim().length < 2}
          style={{ padding: '8px 18px', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
          {loading ? '검색 중...' : '검색'}
        </button>
        {results !== null && (
          <button type="button" className="btn btn-outline" onClick={handleClear}
            style={{ padding: '8px 14px', fontSize: '0.9rem', whiteSpace: 'nowrap' }}>
            ✕ 닫기
          </button>
        )}
      </form>

      {error && (
        <p style={{ color: '#ff5252', fontSize: '0.85rem', marginBottom: 12 }}>❌ {error}</p>
      )}

      {results !== null && !error && (
        <div>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: 12 }}>
            "{submittedQuery}" 검색 결과: {results.length}건
          </p>
          {results.length === 0 ? (
            <p style={{ color: 'var(--text-muted)', textAlign: 'center', padding: 30 }}>
              일치하는 글이 없습니다.
            </p>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {results.map(p => <PostCard key={p.postId} post={p} />)}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
